const formatTitle = (title) => {
  const capitalizedTitle = title.charAt(0).toUpperCase() + title.slice(1);
  if (title.includes('-')) {
    const modifiedTitle = capitalizedTitle.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    if (modifiedTitle === 'Roles Permissions') {
      return 'Roles & Permissions';
    }
    return modifiedTitle;
  }
  if (capitalizedTitle === 'Billing') {
    return 'Usage & Billing';
  }
  return capitalizedTitle;
};

export default formatTitle;
